// Time entry for assessment without video. There is no player to scrub, so the
// minute is typed by hand - and referees think in minutes ("the 45th"), not in
// MM:SS. Both a bare minute and MM:SS are accepted, on either side of the "+"
// that marks added time, and the value is normalised to MM:SS on blur so what
// reaches ObservationsController#typed_time_applied? is always canonical.
//
// These rules are mirrored server side (observations_controller.rb). Keep the
// two in step: spec/javascript/no_video_time.spec.js and the request specs in
// spec/requests/observations_spec.rb cover the same table of inputs.

const MAX_MINUTE_DIGITS = 3;

const pad = (value) => (value.length < 2 ? `0${value}` : value);

// While typing. The colon is re-derived from the digits on every keystroke
// rather than preserved, so that typing never drops a character: keeping a
// colon in place made the seconds a closed two-digit slot, and the 5 of "1245"
// fell off the end. Reading the last two digits as the seconds is what keeps a
// typed "0:30" intact - the old mask split after a fixed two digits and turned
// it into "03:0".
const maskPart = (part) => {
  const digits = part.replace(/\D/g, "").slice(0, MAX_MINUTE_DIGITS + 2);

  // Under three digits it is still a minute being typed: leave it alone and let
  // the blur handler finish the job.
  if (digits.length <= 2) return digits;

  return `${digits.slice(0, -2)}:${digits.slice(-2)}`;
};

const normalisePart = (part) => {
  if (part === "") return "";

  const colon = part.indexOf(":");
  if (colon === -1) return `${pad(part)}:00`;

  const minutes = part.slice(0, colon) || "0";
  const seconds = part.slice(colon + 1) || "0";

  return `${pad(minutes)}:${pad(seconds)}`;
};

const mapParts = (raw, fn) => String(raw).split("+").map(fn).join("+");

export function maskNoVideoTime(raw) {
  return mapParts(raw, maskPart);
}

export function normalizeNoVideoTime(raw) {
  const trimmed = String(raw).trim();
  if (trimmed === "") return "";

  // Drop empty sides so a half-typed "45+" settles as plain "45:00" rather than
  // as the unreadable "45:00+".
  return trimmed
    .split("+")
    .map(normalisePart)
    .filter((part) => part !== "")
    .join("+");
}

// Delegated on document so the fields the edit modal and the post-save re-render
// inject over AJAX are covered without rebinding per form.
export function bindNoVideoTimeFields() {
  $(document)
    .off(".noVideoTime")
    .on("input.noVideoTime", ".observation-no-video-time", function () {
      this.value = maskNoVideoTime(this.value);
    })
    .on("blur.noVideoTime", ".observation-no-video-time", function () {
      this.value = normalizeNoVideoTime(this.value);
    });
}
